import { render, staticRenderFns } from "./TaskTabGrid.vue?vue&type=template&id=0acb0ad6&scoped=true&"
import script from "./TaskTabGrid.vue?vue&type=script&lang=ts&"
export * from "./TaskTabGrid.vue?vue&type=script&lang=ts&"
import style0 from "./TaskTabGrid.vue?vue&type=style&index=0&id=0acb0ad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acb0ad6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VMenu,VRow,VTooltip})
